var map = {
	"./24-support.svg": 27874,
	"./3d-cube-scan.svg": 90091,
	"./3d-rotate.svg": 55533,
	"./3d-square.svg": 76493,
	"./3dcube.svg": 93480,
	"./3square.svg": 67844,
	"./activity.svg": 17605,
	"./add-circle.svg": 23784,
	"./add-square.svg": 49713,
	"./add.svg": 37675,
	"./additem.svg": 14630,
	"./airdrop.svg": 15089,
	"./airplane-square.svg": 43376,
	"./airplane.svg": 24464,
	"./airpod.svg": 78059,
	"./airpods.svg": 78402,
	"./alarm.svg": 57669,
	"./align-bottom.svg": 9259,
	"./align-horizontally.svg": 15719,
	"./align-left.svg": 2621,
	"./align-right.svg": 44512,
	"./align-vertically.svg": 78365,
	"./aquarius.svg": 81681,
	"./archive-1.svg": 57150,
	"./archive-add.svg": 26318,
	"./archive-book.svg": 34638,
	"./archive-minus.svg": 33271,
	"./archive-slash.svg": 27816,
	"./archive-tick.svg": 81906,
	"./archive.svg": 20560,
	"./arrange-circle-2.svg": 58186,
	"./arrange-circle.svg": 76975,
	"./arrange-square-2.svg": 41463,
	"./arrange-square.svg": 33982,
	"./arrow-2.svg": 58452,
	"./arrow-3.svg": 96437,
	"./arrow-bottom.svg": 50447,
	"./arrow-circle-down.svg": 55403,
	"./arrow-circle-left.svg": 22380,
	"./arrow-circle-right.svg": 28243,
	"./arrow-down-1.svg": 37040,
	"./arrow-down-2.svg": 98531,
	"./arrow-down.svg": 42578,
	"./arrow-left-1.svg": 12355,
	"./arrow-left-2.svg": 46256,
	"./arrow-left-3.svg": 44705,
	"./arrow-left.svg": 31961,
	"./arrow-right-1.svg": 37962,
	"./arrow-right-2.svg": 29337,
	"./arrow-right-3.svg": 63944,
	"./arrow-right.svg": 3620,
	"./arrow-square-down.svg": 93372,
	"./arrow-square-left.svg": 15819,
	"./arrow-square-right.svg": 28814,
	"./arrow-square-up.svg": 43191,
	"./arrow-square.svg": 54775,
	"./arrow-swap-horizontal.svg": 87364,
	"./arrow-up-1.svg": 99003,
	"./arrow-up-2.svg": 17640,
	"./arrow-up-3.svg": 25561,
	"./arrow-up.svg": 67041,
	"./arrow.svg": 60069,
	"./attach-circle.svg": 9870,
	"./attach-square.svg": 75523,
	"./audio-square.svg": 32020,
	"./autobrightness.svg": 43046,
	"./award.svg": 58797,
	"./back-square.svg": 3353,
	"./backward-10-seconds.svg": 23241,
	"./backward-15-seconds.svg": 11244,
	"./backward-5-seconds.svg": 19331,
	"./backward-item.svg": 97047,
	"./backward.svg": 59189,
	"./bag-2.svg": 89545,
	"./bag-cross-1.svg": 14613,
	"./bag-cross.svg": 61315,
	"./bag-happy.svg": 92337,
	"./bag-tick-2.svg": 871,
	"./bag-tick.svg": 70958,
	"./bag-timer.svg": 480,
	"./bag.svg": 11924,
	"./bank.svg": 47308,
	"./barcode.svg": 23790,
	"./battery-3full.svg": 65730,
	"./battery-charging.svg": 80711,
	"./battery-disable.svg": 21294,
	"./battery-empty-1.svg": 29599,
	"./battery-empty.svg": 32557,
	"./battery-full.svg": 37025,
	"./bezier.svg": 823,
	"./bill.svg": 60865,
	"./bitcoin-card.svg": 57647,
	"./bitcoin-convert.svg": 49818,
	"./bitcoin-refresh.svg": 23074,
	"./blend-2.svg": 47502,
	"./blend.svg": 55147,
	"./bluetooth-2.svg": 73697,
	"./bluetooth-circle.svg": 55369,
	"./bluetooth-rectangle.svg": 5992,
	"./bluetooth.svg": 93852,
	"./blur.svg": 62393,
	"./book-1.svg": 63743,
	"./book-saved.svg": 879,
	"./book-square.svg": 63007,
	"./book.svg": 84941,
	"./bookmark-2.svg": 94159,
	"./bookmark.svg": 81478,
	"./box-1.svg": 44679,
	"./box-2.svg": 96468,
	"./box-add.svg": 34503,
	"./box-remove.svg": 2758,
	"./box-search.svg": 85434,
	"./box-tick.svg": 15545,
	"./box-time.svg": 66197,
	"./box.svg": 5573,
	"./briefcase.svg": 96490,
	"./brifecase-cross.svg": 68455,
	"./brifecase-tick.svg": 54202,
	"./brifecase-timer.svg": 87012,
	"./broom.svg": 48521,
	"./brush-1.svg": 48060,
	"./brush-2.svg": 50383,
	"./brush-3.svg": 13982,
	"./brush-4.svg": 31361,
	"./brush.svg": 69798,
	"./bubble.svg": 69516,
	"./bucket-circle.svg": 12441,
	"./bucket-square.svg": 1116,
	"./bucket.svg": 11180,
	"./building-3.svg": 90522,
	"./building-4.svg": 85797,
	"./building.svg": 17770,
	"./buildings-2.svg": 41476,
	"./buildings.svg": 69397,
	"./buliding.svg": 79044,
	"./bus.svg": 2668,
	"./buy-crypto.svg": 60784,
	"./cake.svg": 1402,
	"./calculator.svg": 54014,
	"./calendar-1.svg": 17058,
	"./calendar-2.svg": 97457,
	"./calendar-add.svg": 19186,
	"./calendar-circle.svg": 53817,
	"./calendar-edit.svg": 46301,
	"./calendar-remove.svg": 86541,
	"./calendar-search.svg": 30985,
	"./calendar-tick.svg": 12198,
	"./calendar.svg": 8012,
	"./call-add.svg": 67968,
	"./call-calling.svg": 66145,
	"./call-incoming.svg": 68015,
	"./call-minus.svg": 3537,
	"./call-outgoing.svg": 58053,
	"./call-received.svg": 81898,
	"./call-remove.svg": 72547,
	"./call-slash.svg": 19082,
	"./call.svg": 54090,
	"./camera-slash.svg": 74719,
	"./camera.svg": 70547,
	"./candle-2.svg": 65372,
	"./candle.svg": 45693,
	"./car.svg": 28996,
	"./card-add.svg": 17566,
	"./card-coin.svg": 19846,
	"./card-edit.svg": 53049,
	"./card-pos.svg": 13477,
	"./card-receive.svg": 70572,
	"./card-remove-1.svg": 20099,
	"./card-remove.svg": 47513,
	"./card-send.svg": 95483,
	"./card-slash.svg": 344,
	"./card-tick-1.svg": 89120,
	"./card-tick.svg": 66050,
	"./card.svg": 22688,
	"./cards.svg": 64419,
	"./category-2.svg": 86519,
	"./category.svg": 56382,
	"./cd.svg": 61495,
	"./chart-1.svg": 67640,
	"./chart-2.svg": 6475,
	"./chart-21.svg": 11360,
	"./chart-3.svg": 3770,
	"./chart-square.svg": 77158,
	"./chart-success.svg": 89836,
	"./chart.svg": 17898,
	"./check.svg": 28214,
	"./chrome.svg": 21488,
	"./clipboard-close.svg": 3179,
	"./clipboard-export.svg": 62459,
	"./clipboard-import.svg": 47214,
	"./clipboard-text.svg": 75132,
	"./clipboard-tick.svg": 71262,
	"./clipboard.svg": 99460,
	"./clock-1.svg": 74986,
	"./clock.svg": 81252,
	"./close-circle.svg": 18719,
	"./close-square.svg": 78126,
	"./cloud-add.svg": 37007,
	"./cloud-change.svg": 41998,
	"./cloud-connection.svg": 87326,
	"./cloud-cross.svg": 41522,
	"./cloud-drizzle.svg": 18580,
	"./cloud-fog.svg": 86986,
	"./cloud-lightning.svg": 62028,
	"./cloud-minus.svg": 11774,
	"./cloud-notif.svg": 30680,
	"./cloud-plus.svg": 24310,
	"./cloud-remove.svg": 83742,
	"./cloud-snow.svg": 9107,
	"./cloud-sunny.svg": 72771,
	"./cloud.svg": 89629,
	"./code-1.svg": 23415,
	"./code-circle.svg": 68322,
	"./code.svg": 70805,
	"./coffee.svg": 25394,
	"./coin-1.svg": 75707,
	"./coin.svg": 68737,
	"./color-swatch.svg": 36564,
	"./colorfilter.svg": 59197,
	"./colors-square.svg": 60034,
	"./command-square.svg": 875,
	"./command.svg": 71641,
	"./component.svg": 69827,
	"./computing.svg": 19928,
	"./convert-3d-cube.svg": 76077,
	"./convert-card.svg": 64894,
	"./convert.svg": 53283,
	"./convertshape-2.svg": 15103,
	"./convertshape.svg": 98550,
	"./copy-success.svg": 57731,
	"./copy.svg": 95109,
	"./copyright.svg": 47761,
	"./courthouse.svg": 33905,
	"./cpu-charge.svg": 46801,
	"./cpu-setting.svg": 95875,
	"./cpu.svg": 94908,
	"./creative-commons.svg": 12360,
	"./crop.svg": 43684,
	"./crown-1.svg": 22401,
	"./crown.svg": 26375,
	"./cup.svg": 95514,
	"./danger.svg": 38883,
	"./data-2.svg": 77151,
	"./data.svg": 64886,
	"./designtools.svg": 98493,
	"./device-message.svg": 4518,
	"./devices.svg": 91543,
	"./diagram.svg": 20889,
	"./diamonds.svg": 41257,
	"./direct-down.svg": 64214,
	"./direct-inbox.svg": 48678,
	"./direct-left.svg": 16221,
	"./direct-normal.svg": 39755,
	"./direct-notification.svg": 63611,
	"./direct-right.svg": 16416,
	"./direct-send.svg": 45168,
	"./direct-up.svg": 71309,
	"./direct.svg": 14105,
	"./directbox-default.svg": 50692,
	"./directbox-notif.svg": 72769,
	"./directbox-receive.svg": 672,
	"./directbox-send.svg": 37663,
	"./discount-circle.svg": 30644,
	"./discount-shape.svg": 8543,
	"./discover.svg": 32247,
	"./dislike.svg": 29135,
	"./document-1.svg": 60711,
	"./document-cloud.svg": 76489,
	"./document-code-2.svg": 35672,
	"./document-code.svg": 78737,
	"./document-copy.svg": 31585,
	"./document-download.svg": 78322,
	"./document-favorite.svg": 61614,
	"./document-filter.svg": 38792,
	"./document-forward.svg": 21777,
	"./document-like.svg": 19487,
	"./document-previous.svg": 68673,
	"./document-sketch.svg": 83946,
	"./document-text-1.svg": 19073,
	"./document-text.svg": 46503,
	"./document-upload.svg": 26945,
	"./document.svg": 80869,
	"./dollar-circle.svg": 10245,
	"./dollar-square.svg": 74488,
	"./driver-2.svg": 79177,
	"./driver-refresh.svg": 42554,
	"./driver.svg": 32596,
	"./driving.svg": 21491,
	"./drop.svg": 73277,
	"./edit-2.svg": 58355,
	"./edit.svg": 24066,
	"./electricity.svg": 54985,
	"./element-1.svg": 19332,
	"./element-2.svg": 62455,
	"./element-3.svg": 74918,
	"./element-4.svg": 77513,
	"./element-equal.svg": 99733,
	"./element-plus.svg": 42327,
	"./emoji-happy.svg": 16225,
	"./emoji-normal.svg": 38004,
	"./emoji-sad.svg": 84631,
	"./empty-wallet-add.svg": 84583,
	"./empty-wallet-remove.svg": 97414,
	"./empty-wallet-tick.svg": 59737,
	"./empty-wallet.svg": 84485,
	"./eraser-1.svg": 3696,
	"./eraser.svg": 13874,
	"./export-1.svg": 78502,
	"./export-2.svg": 77637,
	"./export-3.svg": 22916,
	"./export.svg": 61512,
	"./external-drive.svg": 58668,
	"./eye-slash.svg": 56533,
	"./eye.svg": 52649,
	"./fatrows.svg": 96148,
	"./favorite-chart.svg": 54613,
	"./filter-add.svg": 32026,
	"./filter-edit.svg": 20677,
	"./filter-remove.svg": 51205,
	"./filter-search.svg": 21169,
	"./filter-square.svg": 46644,
	"./filter-tick.svg": 81566,
	"./filter.svg": 52196,
	"./finger-cricle.svg": 56564,
	"./finger-scan.svg": 84525,
	"./firstline.svg": 36966,
	"./flag-2.svg": 65769,
	"./flag.svg": 308,
	"./flash-1.svg": 44414,
	"./flash-circle-1.svg": 46959,
	"./flash-circle.svg": 56125,
	"./flash-slash.svg": 87112,
	"./flash.svg": 45648,
	"./folder-2.svg": 92487,
	"./folder-add.svg": 18412,
	"./folder-cloud.svg": 23026,
	"./folder-connection.svg": 45531,
	"./folder-cross.svg": 48801,
	"./folder-favorite.svg": 54063,
	"./folder-minus.svg": 42693,
	"./folder-open.svg": 48331,
	"./folder.svg": 23598,
	"./forbidden-2.svg": 84440,
	"./forbidden.svg": 38705,
	"./format-circle.svg": 22432,
	"./format-square.svg": 54697,
	"./forward-10-seconds.svg": 81929,
	"./forward-15-seconds.svg": 69932,
	"./forward-5-seconds.svg": 45411,
	"./forward-item.svg": 9463,
	"./forward-square.svg": 20583,
	"./forward.svg": 82421,
	"./frame-1.svg": 96195,
	"./frame-2.svg": 34704,
	"./frame-3.svg": 46945,
	"./frame-4.svg": 38014,
	"./frame-5.svg": 591,
	"./frame.svg": 68665,
	"./gallery-add.svg": 86570,
	"./gallery-edit.svg": 98677,
	"./gallery-export.svg": 71915,
	"./gallery-favorite.svg": 60513,
	"./gallery-import.svg": 62334,
	"./gallery-remove.svg": 4501,
	"./gallery-slash.svg": 92668,
	"./gallery-tick.svg": 3854,
	"./gallery.svg": 92884,
	"./game.svg": 21736,
	"./gameboy.svg": 28842,
	"./gemini-2.svg": 44110,
	"./gemini.svg": 27147,
	"./ghost.svg": 26619,
	"./gift.svg": 928,
	"./glass-1.svg": 91544,
	"./glass.svg": 10858,
	"./global-edit.svg": 24508,
	"./global-refresh.svg": 74897,
	"./global-search.svg": 28980,
	"./global.svg": 85551,
	"./gps-slash.svg": 40878,
	"./gps.svg": 43134,
	"./grammerly.svg": 73744,
	"./graph.svg": 32926,
	"./grid-1.svg": 68116,
	"./grid-2.svg": 39623,
	"./grid-3.svg": 86,
	"./grid-4.svg": 83769,
	"./grid-5.svg": 2024,
	"./grid-6.svg": 83387,
	"./grid-7.svg": 41418,
	"./grid-8.svg": 9693,
	"./grid-9.svg": 97500,
	"./grid-edit.svg": 26211,
	"./grid-eraser.svg": 66311,
	"./grid-lock.svg": 59830,
	"./happyemoji.svg": 46342,
	"./hashtag-1.svg": 11304,
	"./hashtag-down.svg": 5235,
	"./hashtag-up.svg": 82252,
	"./hashtag.svg": 67514,
	"./headphone.svg": 24544,
	"./headphones.svg": 37539,
	"./health.svg": 93728,
	"./heart-add.svg": 36032,
	"./heart-circle.svg": 36471,
	"./heart-edit.svg": 2103,
	"./heart-remove.svg": 72419,
	"./heart-search.svg": 87743,
	"./heart-slash.svg": 25290,
	"./heart-tick.svg": 29392,
	"./heart.svg": 11402,
	"./hierarchy-2.svg": 84002,
	"./hierarchy-3.svg": 14579,
	"./hierarchy-square-2.svg": 18428,
	"./hierarchy-square-3.svg": 46973,
	"./hierarchy-square.svg": 84445,
	"./hierarchy.svg": 97399,
	"./home-1.svg": 2553,
	"./home-2.svg": 58154,
	"./home-hashtag.svg": 43400,
	"./home-trend-down.svg": 72154,
	"./home-trend-up.svg": 33481,
	"./home-wifi.svg": 24367,
	"./home.svg": 66767,
	"./hospital.svg": 60224,
	"./house-2.svg": 45935,
	"./house.svg": 32838,
	"./icon-1.svg": 31735,
	"./icon-2.svg": 88612,
	"./icon-3.svg": 39781,
	"./icon.svg": 60245,
	"./image.svg": 83213,
	"./import-1.svg": 23111,
	"./import-2.svg": 74900,
	"./import.svg": 15973,
	"./info-circle.svg": 51307,
	"./information.svg": 96316,
	"./instagram.svg": 80590,
	"./judge.svg": 50399,
	"./kanban.svg": 82291,
	"./key-square.svg": 9761,
	"./key.svg": 68059,
	"./keyboard-open.svg": 30274,
	"./keyboard.svg": 18941,
	"./lamp-1.svg": 4250,
	"./lamp-charge.svg": 92761,
	"./lamp-on.svg": 55282,
	"./lamp-slash.svg": 43324,
	"./lamp.svg": 61364,
	"./language-circle.svg": 39365,
	"./language-square.svg": 33080,
	"./layer.svg": 20181,
	"./level.svg": 85800,
	"./lifebuoy.svg": 75499,
	"./like-1.svg": 51037,
	"./like-dislike.svg": 85753,
	"./like-shapes.svg": 15514,
	"./like-tag.svg": 22316,
	"./like.svg": 8731,
	"./link-1.svg": 10404,
	"./link-2.svg": 37175,
	"./link-21.svg": 15652,
	"./link-circle.svg": 85019,
	"./link-square.svg": 25786,
	"./link.svg": 94462,
	"./location-add.svg": 75829,
	"./location-cross.svg": 89972,
	"./location-minus.svg": 68708,
	"./location-slash.svg": 56287,
	"./location-tick.svg": 64587,
	"./location.svg": 60275,
	"./lock-1.svg": 40297,
	"./lock-circle.svg": 63740,
	"./lock-slash.svg": 56059,
	"./lock.svg": 15679,
	"./login-1.svg": 89695,
	"./login.svg": 90701,
	"./logout-1.svg": 24586,
	"./logout.svg": 55364,
	"./lovely.svg": 72723,
	"./magic-star.svg": 59324,
	"./magicpen.svg": 93860,
	"./main-component.svg": 21571,
	"./man.svg": 23394,
	"./map-1.svg": 40602,
	"./map.svg": 75252,
	"./mask-1.svg": 82836,
	"./mask-2.svg": 47399,
	"./mask.svg": 95790,
	"./math.svg": 68000,
	"./maximize-1.svg": 77646,
	"./maximize-2.svg": 60621,
	"./maximize-21.svg": 23590,
	"./maximize-3.svg": 13260,
	"./maximize-4.svg": 35827,
	"./maximize-circle.svg": 51501,
	"./maximize.svg": 33664,
	"./medal-star.svg": 69836,
	"./medal.svg": 56315,
	"./menu-1.svg": 45665,
	"./menu-board.svg": 97632,
	"./menu.svg": 6439,
	"./message-2.svg": 64942,
	"./message-add-1.svg": 2543,
	"./message-add.svg": 94365,
	"./message-circle.svg": 77608,
	"./message-edit.svg": 84208,
	"./message-favorite.svg": 81576,
	"./message-minus.svg": 42204,
	"./message-notif.svg": 61474,
	"./message-programming.svg": 46523,
	"./message-question.svg": 29768,
	"./message-remove.svg": 58884,
	"./message-search.svg": 48040,
	"./message-square.svg": 14737,
	"./message-text-1.svg": 49243,
	"./message-text.svg": 32353,
	"./message-tick.svg": 29731,
	"./message-time.svg": 57391,
	"./message.svg": 3851,
	"./messages-1.svg": 25152,
	"./messages-2.svg": 45907,
	"./messages-3.svg": 24386,
	"./messages.svg": 33346,
	"./microphone-2.svg": 50587,
	"./microphone-slash-1.svg": 16040,
	"./microphone-slash.svg": 11898,
	"./microphone.svg": 58234,
	"./microscope.svg": 85446,
	"./milk.svg": 85283,
	"./mini-music-sqaure.svg": 64579,
	"./minus-cirlce.svg": 69661,
	"./minus-square.svg": 59070,
	"./minus.svg": 14466,
	"./mirror.svg": 60231,
	"./mirroring-screen.svg": 29218,
	"./mobile-programming.svg": 51168,
	"./mobile.svg": 93276,
	"./money-2.svg": 77719,
	"./money-3.svg": 90182,
	"./money-4.svg": 92777,
	"./money-add.svg": 57532,
	"./money-change.svg": 6767,
	"./money-forbidden.svg": 95878,
	"./money-recive.svg": 78823,
	"./money-remove.svg": 95311,
	"./money-send.svg": 9349,
	"./money-tick.svg": 50396,
	"./money-time.svg": 93148,
	"./money.svg": 22622,
	"./moneys.svg": 78337,
	"./monitor-mobbile.svg": 24935,
	"./monitor-recorder.svg": 88367,
	"./monitor.svg": 63020,
	"./moon.svg": 82213,
	"./more-2.svg": 82680,
	"./more-circle.svg": 93038,
	"./more-square.svg": 58691,
	"./more.svg": 26545,
	"./mouse-1.svg": 39909,
	"./mouse-circle.svg": 52496,
	"./mouse-square.svg": 13209,
	"./mouse.svg": 82227,
	"./music-circle.svg": 80000,
	"./music-dashboard.svg": 78192,
	"./music-filter.svg": 63018,
	"./music-library-2.svg": 91476,
	"./music-play.svg": 87826,
	"./music-playlist.svg": 70014,
	"./music-square-add.svg": 22787,
	"./music-square-remove.svg": 30194,
	"./music-square-search.svg": 38934,
	"./music-square.svg": 28617,
	"./music.svg": 323,
	"./musicnote.svg": 80763,
	"./next.svg": 78357,
	"./note-1.svg": 75248,
	"./note-2.svg": 20387,
	"./note-21.svg": 4712,
	"./note-add.svg": 75960,
	"./note-favorite.svg": 54635,
	"./note-remove.svg": 98955,
	"./note-square.svg": 32270,
	"./note-text.svg": 33326,
	"./note.svg": 39666,
	"./notification-1.svg": 3429,
	"./notification-bing.svg": 68866,
	"./notification-circle.svg": 97264,
	"./notification-favorite.svg": 72592,
	"./notification-status.svg": 30562,
	"./notification.svg": 63923,
	"./omega-circle.svg": 18408,
	"./omega-square.svg": 55537,
	"./paintbucket.svg": 41504,
	"./paperclip-2.svg": 91503,
	"./paperclip.svg": 86854,
	"./password-check.svg": 27722,
	"./path-2.svg": 5702,
	"./path-square.svg": 52153,
	"./path.svg": 47795,
	"./pause-circle.svg": 40745,
	"./pause.svg": 43900,
	"./pen-add.svg": 30433,
	"./pen-close.svg": 69988,
	"./pen-remove.svg": 43528,
	"./pen-tool-2.svg": 94879,
	"./pen-tool.svg": 68630,
	"./people.svg": 91331,
	"./percentage-circle.svg": 54371,
	"./percentage-square.svg": 91522,
	"./personalcard.svg": 78976,
	"./pet.svg": 71917,
	"./pharagraphspacing.svg": 54071,
	"./picture-frame.svg": 85260,
	"./play-add.svg": 82954,
	"./play-circle.svg": 34753,
	"./play-cricle.svg": 84807,
	"./play-remove.svg": 92565,
	"./play.svg": 94676,
	"./presention-chart.svg": 50872,
	"./previous.svg": 62253,
	"./printer-slash.svg": 82970,
	"./printer.svg": 45370,
	"./profile-2user.svg": 8437,
	"./profile-add.svg": 55127,
	"./profile-circle.svg": 36866,
	"./profile-delete.svg": 99299,
	"./profile-remove.svg": 84726,
	"./profile-tick.svg": 11337,
	"./profile.svg": 20341,
	"./programming-arrow.svg": 66349,
	"./programming-arrows.svg": 47044,
	"./quote-down-circle.svg": 19224,
	"./quote-down-square.svg": 76545,
	"./quote-down.svg": 9243,
	"./quote-up-circle.svg": 81057,
	"./quote-up-square.svg": 2308,
	"./quote-up.svg": 53876,
	"./radar-1.svg": 14420,
	"./radar-2.svg": 62631,
	"./radar.svg": 27470,
	"./radio.svg": 66723,
	"./ram-2.svg": 13671,
	"./ram.svg": 52622,
	"./ranking-1.svg": 91634,
	"./ranking.svg": 21916,
	"./receipt-1.svg": 58132,
	"./receipt-2-1.svg": 95969,
	"./receipt-2.svg": 45991,
	"./receipt-add.svg": 45964,
	"./receipt-discount.svg": 62994,
	"./receipt-disscount.svg": 72969,
	"./receipt-edit.svg": 64355,
	"./receipt-item.svg": 19882,
	"./receipt-minus.svg": 64005,
	"./receipt-search.svg": 79227,
	"./receipt-square.svg": 1610,
	"./receipt-text.svg": 68210,
	"./receipt.svg": 60334,
	"./receive-square-2.svg": 39546,
	"./receive-square.svg": 70911,
	"./received.svg": 81083,
	"./record-circle.svg": 90042,
	"./record.svg": 98541,
	"./recovery-convert.svg": 91365,
	"./redo.svg": 61806,
	"./refresh-2.svg": 38910,
	"./refresh-circle.svg": 77304,
	"./refresh-left-square.svg": 41349,
	"./refresh-right-square.svg": 58390,
	"./refresh-square-2.svg": 95272,
	"./refresh.svg": 84667,
	"./repeat-circle.svg": 12796,
	"./repeat.svg": 31615,
	"./repeate-music.svg": 43430,
	"./repeate-one.svg": 5743,
	"./reserve.svg": 53586,
	"./rotate-left-1.svg": 53201,
	"./rotate-left.svg": 89527,
	"./rotate-right-1.svg": 72112,
	"./rotate-right.svg": 53682,
	"./route-square.svg": 13691,
	"./routing-2.svg": 13777,
	"./routing.svg": 83404,
	"./row-horizontal.svg": 60871,
	"./row-vertical.svg": 10613,
	"./ruler&pen.svg": 6301,
	"./ruler.svg": 71046,
	"./safe-home.svg": 34763,
	"./sagittarius.svg": 32704,
	"./save-2.svg": 30356,
	"./save-add.svg": 20391,
	"./save-minus.svg": 54950,
	"./save-remove.svg": 19430,
	"./scan-barcode.svg": 19578,
	"./scan.svg": 68333,
	"./scanner.svg": 13632,
	"./scanning.svg": 22543,
	"./scissor-1.svg": 75470,
	"./scissor.svg": 12768,
	"./screenmirroring.svg": 71125,
	"./scroll.svg": 11729,
	"./search-favorite-1.svg": 87433,
	"./search-favorite.svg": 51391,
	"./search-normal-1.svg": 84956,
	"./search-normal.svg": 17286,
	"./search-status-1.svg": 52311,
	"./search-status.svg": 10709,
	"./search-zoom-in-1.svg": 47976,
	"./search-zoom-in.svg": 87226,
	"./search-zoom-out-1.svg": 37631,
	"./search-zoom-out.svg": 51757,
	"./security-card.svg": 52679,
	"./security-safe.svg": 65570,
	"./security-time.svg": 91662,
	"./security-user.svg": 13752,
	"./security.svg": 94900,
	"./send-1.svg": 83590,
	"./send-2.svg": 6021,
	"./send-sqaure-2.svg": 28149,
	"./send-square.svg": 47240,
	"./send.svg": 70152,
	"./setting-2.svg": 97715,
	"./setting-3.svg": 93986,
	"./setting-4.svg": 22509,
	"./setting-5.svg": 75148,
	"./setting.svg": 578,
	"./settings.svg": 79933,
	"./shapes-1.svg": 97234,
	"./shapes.svg": 71548,
	"./share.svg": 58491,
	"./shield-cross.svg": 67002,
	"./shield-search.svg": 33498,
	"./shield-security.svg": 67488,
	"./shield-slash.svg": 34913,
	"./shield-tick.svg": 32985,
	"./shield.svg": 74885,
	"./ship.svg": 624,
	"./shop-add.svg": 39624,
	"./shop-remove.svg": 36955,
	"./shop.svg": 80258,
	"./shopping-bag.svg": 24495,
	"./shopping-cart.svg": 18969,
	"./shuffle.svg": 5025,
	"./sidebar-bottom.svg": 88570,
	"./sidebar-left.svg": 82396,
	"./sidebar-right.svg": 72099,
	"./sidebar-top.svg": 52448,
	"./signpost.svg": 11251,
	"./simcard-1.svg": 80539,
	"./simcard-2.svg": 99176,
	"./simcard.svg": 54369,
	"./size.svg": 66545,
	"./slash.svg": 89661,
	"./slider-horizontal-1.svg": 19108,
	"./slider-horizontal.svg": 68190,
	"./slider-vertical-1.svg": 70474,
	"./slider-vertical.svg": 66404,
	"./slider.svg": 89845,
	"./smallcaps.svg": 53740,
	"./smart-car.svg": 61288,
	"./smart-home.svg": 54771,
	"./smileys.svg": 67446,
	"./sms-edit.svg": 56066,
	"./sms-notification.svg": 63539,
	"./sms-search.svg": 1214,
	"./sms-star.svg": 29806,
	"./sms-tracking.svg": 34037,
	"./sms.svg": 77217,
	"./sort.svg": 87990,
	"./sound.svg": 5115,
	"./speaker.svg": 61649,
	"./speedometer.svg": 95485,
	"./star-1.svg": 56660,
	"./star-slash.svg": 52766,
	"./star.svg": 21102,
	"./status-up.svg": 650,
	"./status.svg": 70932,
	"./sticker.svg": 12287,
	"./stickynote.svg": 76995,
	"./stop-circle.svg": 67243,
	"./stop.svg": 10862,
	"./story.svg": 12042,
	"./strongbox-2.svg": 17055,
	"./strongbox.svg": 86550,
	"./subtitle.svg": 93978,
	"./sun-1.svg": 47394,
	"./sun-fog.svg": 92767,
	"./sun.svg": 8588,
	"./tag-2.svg": 44327,
	"./tag-cross.svg": 66593,
	"./tag-right.svg": 29207,
	"./tag-user.svg": 44278,
	"./tag.svg": 1454,
	"./task-square.svg": 12167,
	"./task.svg": 92757,
	"./teacher.svg": 65484,
	"./text-block.svg": 69047,
	"./text-bold.svg": 25917,
	"./text-italic.svg": 32436,
	"./text-underline.svg": 76944,
	"./text.svg": 50555,
	"./textalign-center.svg": 11636,
	"./textalign-justifycenter.svg": 76142,
	"./textalign-justifyleft.svg": 65330,
	"./textalign-justifyright.svg": 68809,
	"./textalign-left.svg": 88160,
	"./textalign-right.svg": 56111,
	"./tick-circle.svg": 51754,
	"./tick-square.svg": 49743,
	"./ticket-2.svg": 411,
	"./ticket-discount.svg": 74550,
	"./ticket-expired.svg": 92594,
	"./ticket-star.svg": 61175,
	"./ticket.svg": 32218,
	"./timer-1.svg": 65699,
	"./timer-pause.svg": 29988,
	"./timer-start.svg": 75670,
	"./timer.svg": 79097,
	"./toggle-off-circle.svg": 37947,
	"./toggle-off.svg": 64574,
	"./toggle-on-circle.svg": 60437,
	"./toggle-on.svg": 15016,
	"./trade.svg": 86296,
	"./transaction-minus.svg": 3545,
	"./translate.svg": 44184,
	"./trash.svg": 45680,
	"./tree.svg": 57877,
	"./trend-down.svg": 56476,
	"./trend-up.svg": 98391,
	"./triangle.svg": 26718,
	"./truck-fast.svg": 14098,
	"./truck-tick.svg": 64767,
	"./truck.svg": 43247,
	"./trush-square.svg": 11164,
	"./undo.svg": 87480,
	"./unlimited.svg": 6819,
	"./unlock.svg": 20338,
	"./user-add.svg": 51553,
	"./user-cirlce-add.svg": 20744,
	"./user-edit.svg": 82148,
	"./user-minus.svg": 50664,
	"./user-octagon.svg": 48569,
	"./user-remove.svg": 8328,
	"./user-search.svg": 95260,
	"./user-square.svg": 66189,
	"./user-tag.svg": 21536,
	"./user-tick.svg": 34743,
	"./user.svg": 65703,
	"./verify.svg": 34081,
	"./video-add.svg": 93677,
	"./video-circle.svg": 11000,
	"./video-horizontal.svg": 25100,
	"./video-octagon.svg": 47981,
	"./video-play.svg": 72682,
	"./video-remove.svg": 63700,
	"./video-slash.svg": 46551,
	"./video-square.svg": 84673,
	"./video-tick.svg": 8339,
	"./video-time.svg": 37535,
	"./video-vertical.svg": 55898,
	"./video.svg": 76443,
	"./voice-cricle.svg": 61823,
	"./voice-square.svg": 66652,
	"./volume-cross.svg": 68395,
	"./volume-high.svg": 63549,
	"./volume-low-1.svg": 87179,
	"./volume-low.svg": 23889,
	"./volume-mute.svg": 52150,
	"./volume-slash.svg": 23828,
	"./volume-up.svg": 15634,
	"./volume.svg": 55516,
	"./wallet-1.svg": 32091,
	"./wallet-2.svg": 81352,
	"./wallet-3.svg": 46745,
	"./wallet-add-1.svg": 59277,
	"./wallet-add-2.svg": 30158,
	"./wallet-add.svg": 49323,
	"./wallet-check.svg": 79030,
	"./wallet-minus.svg": 58690,
	"./wallet-money.svg": 75326,
	"./wallet-remove.svg": 14218,
	"./wallet-search.svg": 25534,
	"./wallet.svg": 6145,
	"./warning-2.svg": 30403,
	"./watch-status.svg": 6266,
	"./watch.svg": 17195,
	"./weight-1.svg": 59028,
	"./weight.svg": 92174,
	"./wifi-square.svg": 8983,
	"./wifi.svg": 19493,
	"./wind-2.svg": 16981,
	"./wind.svg": 13720,
	"./woman.svg": 72460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65204;